import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {AngularMultiSelectModule} from '../../angular2-multiselect-dropdown/multiselect.component';
import {DatetimeModule} from '../../datetime/datetime.module';
import {FieldsModule} from '../../fields/fields.module';

import {CommonComponentsModule} from '../../../common-components.module';
import {AngularMaterialImportModule} from '../../angular-material-import-module/angular-material-import.module';
import {CaptureImageModalComponent} from './capture-image-modal.component';
import {ImageCropperModule} from 'ngx-image-cropper';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        RouterModule,
        AngularMultiSelectModule,
        DatetimeModule,
        CommonComponentsModule,
        AngularMaterialImportModule,
        FieldsModule,
        ImageCropperModule
    ],
    declarations: [
        CaptureImageModalComponent
    ],
    exports: [
        CaptureImageModalComponent
    ],
    providers: [],
})
export class CaptureImageModalModule {
}



// WEBPACK FOOTER //
// /app/src/app/components/directory/capture-image-modal/capture-image-modal.module.ts